import StorageFactory from './StorageFactory';
const localStore = new StorageFactory(localStorage);
const sessionStore = new StorageFactory(sessionStorage);
export { localStore, sessionStore };
